<template>
  <div>
    <div class="nav">
      <div class="logo-wrapper">
        <a href="/">
          <div class="codelos-logo">
            <svg
              style="transform: rotate(11deg)"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              viewBox="-0.5 -0.5 538 439"
              content='<mxfile host="www.draw.io" modified="2020-07-07T16:35:48.281Z" agent="5.0 (Macintosh; Intel Mac OS X 10_15_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/83.0.4103.116 Safari/537.36" version="13.3.6" etag="TN6qjrQkVujqEMhigEsy" type="device"><diagram id="g3IF2AxwIblVb2gJ5hIN">5Vhdc6MgFP01edyOgPjx2Kbt7sPuTGf6sM8kUmUWxUHSpPvrFyNoRBudNMnOtD4kerlcuOdcDuICLfPdd0nK7JdIKF9AL9kt0P0CQuDDQP/VlrfGEka4MaSSJcapMzyzv9QYPWPdsIRWPUclBFes7BvXoijoWvVsREqx7bu9CN4ftSQpHRie14QPrb9ZorLGGsGws/+gLM3syCCIm5acWGeTSZWRRGwPTOhhgZZSCNXc5bsl5TV4Fpem3+M7re3EJC3UnA6w6fBK+MbkZual3myyqRSb0rhRqehuDGKysu7ecAqgTUxXBBU5VfJNu9hAtospBmQetx2y2LpkB6j61kgMm2kbuktY35icx/NH0/nr9IuE1v5gge62GVP0uSTrunWry1vbMpVz01wpKf60RQGxNr0wzpeCC7kPh7z9pe3vQnoIHTwOndeHDoAhdgiMYAf9M2DnT2NXZ8f0uvlJVpQ/iYopJgrdtBJKiVyDYB1uOUvrBiVcQDNS1sHyXVpryc2KVGx9Q+R6DzaR6rZI96N5NxgjH0T6B4VBhPSSQ3e0SLr2GHuhF0Mf+xGOMYzH6ZJCETPLb7E35O9xf7V9x1rOwCz0cI9Z6A2Zbdk/ZLY1foRZPM1sjWytpPqpEAWdXAVNAJoMhHUSkUMdGEnY2iTlmrfXfvgxEMwIT4LpgTvAY398KdkQldjINTW9DhXVCYRgP5C70nTNplQN4uwpabOexVIwgyXO9Z5Ip3WLVGWzUb6wXa11DoVgZCGcU8iQh4aif4TsjxR3eGXYLqsTbtmGI7vnhYCM/m/9XUeIW0BbgMHVAI6/kAzbfQ6dKLuBQ1NwMdm1G8OXoGUcXRidyBJw4rgzOSNLYJql5mTTf+UD0dEtbc5x57ig+NipVDxU7HDsxc4/wtpcRQEzznsXqF3wzgnwSsULe4AHToC5tduPAlyhOmPpzjiUfjqSHHRP1BfcDxNejqMZh9/PtgmAuK9cgw8ws1eS+8XHfVk6mSf92H07a9y7L5Do4R8=</diagram></mxfile>'
            >
              <g style="fill: rgb(255, 255, 255); stroke: rgb(255, 255, 255)">
                <rect
                  x="112"
                  y="115"
                  width="310"
                  height="240"
                  rx="36"
                  ry="36"
                  stroke-width="25"
                  pointer-events="all"
                />
                <path
                  d="M 306 115 L 336 45"
                  stroke-width="25"
                  stroke-miterlimit="10"
                  pointer-events="stroke"
                />
                <ellipse
                  cx="340"
                  cy="30"
                  rx="25"
                  ry="25"
                  stroke-width="10"
                  pointer-events="all"
                />
                <path
                  d="M 12 235 L 72 165"
                  fill="none"
                  stroke-width="25"
                  stroke-miterlimit="10"
                  pointer-events="stroke"
                />
                <path
                  d="M 72 285 L 22 226"
                  fill="none"
                  stroke-width="25"
                  stroke-miterlimit="10"
                  pointer-events="stroke"
                />
                <path
                  d="M 524 216 L 464 285"
                  fill="none"
                  stroke-width="25"
                  stroke-miterlimit="10"
                  pointer-events="stroke"
                />
                <path
                  d="M 464 165 L 514 225"
                  fill="none"
                  stroke-width="25"
                  stroke-miterlimit="10"
                  pointer-events="stroke"
                />
                <path
                  d="M 202 425 L 232 355"
                  fill="none"
                  stroke-width="25"
                  stroke-miterlimit="10"
                  pointer-events="stroke"
                />
              </g>
              <g style="fill: rgb(254, 52, 102); stroke: rgb(254, 52, 102)">
                <path
                  d="M 250.53 302.21 C 230.23 295.13 216.73 275.85 217 254.35 C 217.28 232.85 231.28 213.93 251.76 207.38"
                  stroke-width="25"
                  stroke-miterlimit="10"
                  transform="rotate(-90,267,255)"
                  pointer-events="all"
                  style="stroke: none"
                />
                <ellipse
                  cx="331"
                  cy="200"
                  rx="25"
                  ry="25"
                  stroke-width="10"
                  pointer-events="all"
                  style="fill: rgb(254, 52, 102); stroke: rgb(254, 52, 102)"
                />
                <ellipse
                  cx="207"
                  cy="201"
                  rx="25"
                  ry="25"
                  stroke-width="10"
                  pointer-events="all"
                />
              </g>
              <defs />
            </svg>
          </div>
        </a>
        <div class="title">
          &nbsp;&nbsp;Codelos.io
          <span class="subcategory">Developer</span>
        </div>
      </div>
    </div>
    <div class="wrapper">
      <div class="row">
        <div class="col-md-4">
          <div class="heading">
            <h1>Fangen wir mit einer kostenlosen Live-Demo an.</h1>
            <p>
              Erleben Sie live auf Ihrem Bildschirm welche Möglichkeiten Codelos Slim EDM bietet. 
            </p>
          </div>
        </div>
        <div class="col">
          <div
            id="calendy"
            class="calendly-inline-widget"
            data-url="https://calendly.com/gharnati/live-demo-slim-edm?text_color=212529&primary_color=ff3366&hide_event_type_details=1"
            style="min-width: 320px; height: 630px"
          ></div>
        </div>
      </div>
      <!-- Calendly Inline-Widget Ende -->
    </div>
  </div>
</template>
<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
export default {
  name: "Subscribe",
  mounted() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    document.head.appendChild(recaptchaScript);
  },
};
</script>

<style scoped>
*,
*::before,
*::after {
  box-sizing: border-box;
}

#calendy .hidden {
  visibility: hidden !important;
}
.wrapper {
  width: 100%;
}

.heading {
  margin-bottom: 24px;
  font-size: 42px;
  font-weight: 400;
  margin-left: 50px;
  margin-top: 150px;
}

.heading h1 {
  margin-bottom: 24px;
  font-size: 41px;
  font-weight: 300;
}

.heading p {
  margin-top: 10px;
  font-size: 16px;
  color: #596377;
}



/**.

Navbar

 */


@import "https://use.fontawesome.com/releases/v5.6.3/css/all.css";
@import "https://fonts.googleapis.com/css?family=Hammersmith+One|Nunito|Orbitron:500|Poiret+One";

/*
font-family: 'Orbitron', sans-serif;
font-family: 'Hammersmith One', sans-serif;
font-family: 'Poiret One', cursive;
font-family: 'Nunito', sans-serif;
*/

.nav {
  display: block;
  background-color: #1f2532;
  color: #f3f7ea;
  width: 100%;
  padding: 14px;
  height: fit-content;
  padding-bottom: 0;
}
.menu1-bar {
  text-transform: uppercase;
  font-size: 10px;
}
.menu2-bar {
  text-transform: uppercase;
  font-size: 12px;
}
.logo-wrapper {
  width: 100%;
  padding-top: 44px;
  margin-left: 10%;
  height: 193px;
  padding-bottom: 36px;
}
.nav .logo {
  float: left;
  font-size: 19px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  line-height: 21px;
  width: 34px;
  border-radius: 5px;
  color: white;
  background-color: rgb(255, 51, 102);
  text-align: left;
  padding: 5px 10px 1px 9px;
}
.title {
  float: left;
  margin: 0 20px 0 0;
  font-size: 33px;
  padding-right: 23px;
  line-height: 33px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  font-family: "Nunito", sans-serif;
  color: white;
  width: 100%;
  line-height: 70px;
}

.nav ul li {
  list-style: none;
  display: inline;
  font-family: "Open Sans", open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #9aa4b3;
  cursor: pointer;
}

.nav ul {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  height: 33px;
}

.nav ul li a {
  text-decoration: none;
  display: block;
  height: 31px;
}

.nav ul li a.active {
  padding: 0;
  margin: 0;
  margin-left: 75px;
  display: block;
  height: 29px;
}

.nav ul li a:hover {
  color: #ffff;
}

.nav ul li a:visited {
  color: #9aa4b3;
  text-decoration: none;
}

.nav .list-item {
  margin: 0 45px 0 0;
  display: inline-block;
}

.nav .menu2-bar .list-item {
  margin: 0 118px 0 0;
  vertical-align: top;
}

.nav .menu2-bar .list-item.active {
  margin: 0 75px 0 0;
  border-bottom: solid 2px rgb(255, 51, 102);
}

.nav .Button__button___1FrBC {
  float: right;
  background: none;
  border: none;
  text-transform: none;
  color: #9aa4b3;
  display: inline;
  font-family: "Open Sans", open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 16px;
  color: #9aa4b3;
  cursor: pointer;
  padding: none;
}

.nav ul li a.more {
  background-image: url("../assets/tree-dots.png");
  display: inline-block;
  width: 30px;
  height: 22px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: -4px 4px;
}

.toggle-list-wrapper .item.more {
  background-image: url("../assets/tree-dots.png");
  width: 30px;
  background-size: 368px 13px;
  background-repeat: no-repeat;
  background-position: 18px -2px;
}

.toggle-list-wrapper .item.more:hover {
  background-color: #fff;
}

.nav ul li a.more:hover {
  background-position: -62px 3px;
}

.toggle-list-wrapper {
  background-color: #ffff;
  position: relative;
  left: -53px;
  top: 36px;
  -webkit-box-shadow: var(--elevation-high);
  box-shadow: var(--elevation-high);
  max-width: 600px;
  overflow: scroll;
  z-index: 2;
  border-radius: 3px;
  display: inline-block;
  clear: both;
  padding: 17px 0 17px 0;
  width: 226px;
  margin-top: 127px;
  margin-top: -47px;
}

.toggle-list-wrapper .item {
  cursor: pointer;
  padding: 9px 23px;
  text-align: left;
  height: fit-content;
  margin: 0;
  font-weight: 300;
  color: #464d5d;
  font-size: 11px;
}
.toggle-list-wrapper .item.last-item {
  border-top: solid 1px #e1e4ea;
}

.toggle-list-wrapper .item:hover {
  background-color: #f0f0f0;
}

.codelos-logo {
  float: left;
  font-size: 19px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
  line-height: 22px;
  width: 55px;
  border-radius: 19px;
  color: white;
  background-color: rgb(255, 51, 102);
  text-align: left;
  padding: 5px 10px 1px 9px;
  transform: rotate(-10deg);
}


/**.

end Navbar

 */




@media (min-width: 414px) {

  .logo-wrapper {
    margin-left: 6%;
  }
}

</style>